import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Capacitor } from "@capacitor/core";
import "@/index.css";
import App from "@/App";
import { initTheme } from "@/lib/theme";
import { notifyLiveUpdateReady } from "@/lib/liveUpdate";
initTheme();
notifyLiveUpdateReady(); // OTA bundle confirmed alive — must run before any network call

// Native app (iOS/Android): install the passkey shim so navigator.credentials
// (FaceID / passkeys) works inside the Capacitor WebView exactly like a browser.
if (Capacitor.isNativePlatform()) {
  import("@capgo/capacitor-passkey")
    .then(({ CapacitorPasskey }) => CapacitorPasskey.autoShimWebAuthn())
    .catch(() => {});
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
